<template>
  <div class="menu-wrapper">
    <!-- <router-link to="/home">
      <el-menu-item class="home-item">
        <svg-icon icon-class="home"></svg-icon>
        <span>首页</span>
      </el-menu-item>
    </router-link> -->

    <template v-for="item in routes" v-if="!item.hidden&&item.children">
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name">
        <el-menu-item v-if="item.children[0].path!='homes'" :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon class="nav-svg-icon" v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>


      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <svg-icon class="nav-svg-icon" v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}  </span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden" >
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0"  :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <span  v-if="child.meta&&child.meta.title" slot="title" style="margin-left: 15px;">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    }
  }
}
</script>
<style lang="scss">
  .el-menu{
    background-color: rgba(0,0,0,0) !important;
  }
  .el-menu-item.submenu-title-noDropdown{
    background-color: none !important;
  }
  .el-menu-item.submenu-title-noDropdown:hover{
    background-color: #afc7ff !important;
  }
  .el-menu-item.is-active.submenu-title-noDropdown{
    background-color: #4f56c2;
  }

  .el-menu-item {
      display: flex;
      align-items: center;
      padding-left: 10px !important;
  }
  .el-submenu__title{
    padding-left: 10px !important;
  }
  .nav-svg-icon{
    width: 20px !important;
    height: 20px !important;
    flex: none;
  }

  .el-submenu__icon-arrow.el-icon-arrow-down{
    color: #191919;
    font-size: 14px;
  }

  #app .sidebar-container .nest-menu .el-submenu > .el-submenu__title, #app .sidebar-container .el-submenu .el-menu-item {
      background-color: #ecf5ff !important;
      border-right: 1px solid #e2e5ef;
  }
  #app .sidebar-container .nest-menu .el-submenu > .el-submenu__title, #app .sidebar-container .el-submenu .el-menu-item:hover {
      background-color: #d1ddfb !important;
  }
  #app .sidebar-container .nest-menu .el-submenu > .el-submenu__title, #app .sidebar-container .el-submenu .el-menu-item.is-active {
      background-color: #4f56c2 !important;
  }
 .el-submenu__title{
      display: flex !important;
      align-items: center !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue